import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Helix.scss';
const Helix = ({ size = 45, color = 'black', speed = 2.5, }) => {
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
        }, children: _jsxs("div", { className: styles.inner, children: [_jsx("div", { className: styles.slice }), _jsx("div", { className: styles.slice }), _jsx("div", { className: styles.slice }), _jsx("div", { className: styles.slice }), _jsx("div", { className: styles.slice }), _jsx("div", { className: styles.slice })] }) }));
};
export default Helix;
